import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const TooltipContainerStyled = styled(Box, {
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  overflow: 'visible',
  fontWeight: '$regular',
});

export const TooltipStyled = styled(Box, {
  display: 'inline-block',
  position: 'absolute',
  maxWidth: '400px',
  minWidth: '200px',
  width: 'auto',
  height: 'auto',
  textJustify: 'auto',
  whiteSpace: 'normal',
  textAlign: 'center',
  padding: '5px',
  borderRadius: '$4',
  zIndex: '$tooltip',
  transition: 'opacity 0.3s',
  boxShadow: '$tooltip',
  backgroundColor: '$white',
  color: '$textPrimary',
  border: `$borderWidths$1 solid $colors$charcoal700`,

  variants: {
    position: {
      left: {
        marginRight: '15px',
        top: '-50%',
        right: '100%',
      },
      right: {
        marginLeft: '15px',
        top: '-50%',
        left: '100%',
      },
      top: {
        marginTop: '-5px',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%) translateY(0)',
      },
      bottom: {
        marginTop: '5px',
        top: '125%',
        left: '20%',
        transform: 'translateX(-20%) translateY(0)',
      },
    },
  },
});

export const TooltipArrowStyled = styled(Box, {
  zIndex: '$tooltip',
  $$borderColor: '$colors$charcoal700',

  variants: {
    position: {
      top: {
        position: 'absolute',
        left: '50%',
        bottom: '1px',

        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: '-16px',
          left: '0',
          border: '7px solid transparent',
          borderTopColor: '$$borderColor',
        },
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: '-15px',
          left: '0',
          border: '7px solid transparent',
          borderTopColor: 'white',
        },
      },
      bottom: {
        position: 'absolute',
        left: '20%',
        top: '1px',

        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '-16px',
          left: '0',
          border: '7px solid transparent',
          borderBottomColor: '$$borderColor',
        },
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '-15px',
          left: '0',
          border: '7px solid transparent',
          borderBottomColor: 'white',
        },
      },
      left: {
        position: 'absolute',
        top: '15px',
        right: '-4px',
        marginRight: '-10px',

        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '1px',
          right: '-1px',
          border: '8px solid transparent',
          borderLeftColor: '$$borderColor',
        },
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '0',
          right: '-1px',
          border: '9px solid transparent',
          borderLeftColor: 'white',
        },
      },
      right: {
        position: 'absolute',
        top: '15px',
        left: '-4px',
        marginLeft: '-10px',

        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '0',
          left: '0',
          border: '7px solid transparent',
          borderRightColor: '$$borderColor',
        },
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: '-1px',
          left: '0',
          border: '8px solid transparent',
          borderRightColor: 'white',
        },
      },
    },
  },
});
